import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import {
  ContactExecuteItemResource,
  ContactExecuteResultResource,
  ContactLostReasonResource,
  ContactDivSettingResource,
  ContactAllSettingResource
} from '@blcloud/bl-ng-resource';
import { SearchConditionPanelModule, OrganizationComboBoxModule, EmployeeGuideModule } from '@blcloud/bl-ng-share-module';
import { ContactStatusBarModule } from '@blcloud/bl-ng-vehicle-customer-module';
import { ScheduleEventCellComponent } from '../schedule-event-cell/schedule-event-cell.component';
import { ContactService } from './contact.service';

/**
 * コンタクト画面モジュール
 *
 * TODO 本当はコンタクト系画面のディレクトリ構成を整理して、このモジュールが子ルーティングを持ったほうがよいけど変更されるか微妙
 */
@NgModule({
  imports: [
    CommonModule,
    SearchConditionPanelModule,
    OrganizationComboBoxModule.forRoot(),
    EmployeeGuideModule.forRoot(),
    ContactStatusBarModule.forRoot(),
    AgGridModule.withComponents([
      ScheduleEventCellComponent
    ])
  ],
  exports: [
    SearchConditionPanelModule,
    OrganizationComboBoxModule,
    EmployeeGuideModule,
    ContactStatusBarModule
  ],
  declarations: [
    ScheduleEventCellComponent
  ],
  providers: [
    ContactExecuteItemResource,
    ContactExecuteResultResource,
    ContactLostReasonResource,
    ContactDivSettingResource,
    ContactAllSettingResource,
    ContactService
  ]
})
export class ContactPageModule { }



// WEBPACK FOOTER //
// ./src/app/shared/contact/contact-page.module.ts